var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49935 9.66667C5.6584 9.66667 4.16602 8.17428 4.16602 6.33333C4.16602 4.49238 5.6584 3 7.49935 3C9.3403 3 10.8327 4.49238 10.8327 6.33333C10.8327 8.17428 9.3403 9.66667 7.49935 9.66667ZM15.8333 9.66699C15.3731 9.66699 15 9.2939 15 8.83366V7.16699H13.3327C12.8724 7.16699 12.4994 6.7939 12.4994 6.33366C12.4994 5.87342 12.8724 5.50033 13.3327 5.50033H15V3.83366C15 3.37342 15.3731 3.00033 15.8333 3.00033C16.2936 3.00033 16.6667 3.37342 16.6667 3.83366V5.50033H18.3327C18.7929 5.50033 19.166 5.87342 19.166 6.33366C19.166 6.7939 18.7929 7.16699 18.3327 7.16699H16.6667V8.83366C16.6667 9.2939 16.2936 9.66699 15.8333 9.66699Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00054307 17.3323C0.323549 13.3551 3.55159 11.333 7.48612 11.333C11.476 11.333 14.7541 13.244 14.9983 17.333C15.008 17.4959 14.9983 17.9997 14.3722 17.9997C11.2843 17.9997 6.6956 17.9997 0.606252 17.9997C0.39726 17.9997 -0.0170515 17.549 0.00054307 17.3323Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.591e16021f6edb7688e67e2d4f4243ab.svg";
export { ForwardRef as ReactComponent };